import {css} from '@emotion/react'

export const cssCFInput = css`
	height: 23px;
	padding: 3px 4px;
	border-radius: 4px;
	border: 1px solid hsl(0, 0%, 80%);
	box-sizing: border-box;
	width: 100%;
	font-size: small;

	&:focus {
		outline: none;
		border: 1px solid #2684FF;
		box-shadow: rgb(38, 132, 255) 0 0 0 1px;
	}
`
